import clsx from "clsx";
import { FunctionComponent } from "react";

import Button from "@ui/components/cta/Button";
import { SELECTORS } from "@ui/config";

import { container } from "./SkipToContent.css";

type Props = {
  anchorId: string;
  text?: string;
  className?: string;
};

const SkipToContent: FunctionComponent<Props> = ({
  anchorId,
  text = "Skip to main content",
  className,
}) => {
  return (
    <Button
      className={clsx(
        SELECTORS.SkipToContent,
        container,
        className && className,
      )}
      displayType="secondary"
      href={`#${anchorId}`}
      text={text}
    />
  );
};

export default SkipToContent;
